import { useTranslation } from "react-i18next"
import { useDispatch, useSelector } from "react-redux"
import { useParams } from "react-router"
import { loadUserLogin } from "../../../../../service/userManagementAction.js"
import { useHistory } from "react-router-dom"
import { formatterRowComponent } from "../../../../../../component/atoms/Tabel/index.jsx"
import { sortCaret, toAbsoluteUrl } from "../../../../../../_metronic/_helpers/index.js"
import { timeStampToDate } from "../../../../../helpers/DateHelper.js"
import { stringFormatting, toMeter } from "../../../../../helpers/TextHelper.js"
import { Button, Card } from "react-bootstrap"
import { CardBody } from "../../../../../../_metronic/_partials/controls/index.js"
import { EmptyCard, TableSkeleton, TableView } from "../../../../../../component/index.jsx"
import { RoutesConstants } from "../../../../../../constants/RoutesConstants.js"
import { linkWithCtrl } from "../../../../../helpers/Utils.js"
import React, { useEffect, useState } from "react"
import { PRIVILEGE_ENUM } from "../../../../../../constants/PrivilegeConstants.js"
import {
  BulkCancelOrderActions,
  GetCancelEnumList,
  setSelectedDataReschedule
} from "../../../../../../redux/actions/OrderAction.jsx"
import { FloatingSelectArea } from "../../../../../../component/atoms/FloatingSelectArea/index.jsx"
import { Popup } from "../../../../../../component/atoms/Popup/index.jsx"
import { Divider } from "@material-ui/core"
import { Skeleton } from "@material-ui/lab"
import {
  BULK_CANCEL_SCHEDULING_BUTTON,
  FIELD_OFFICER_ROLE_STRING,
  ROUTING_STATUS,
  SCHEDULING_STATUS_ENUM
} from "../../../../../../constants/StringConstant.js"
import {
  ICON_CONSTANTS,
  ILLUSTRATION_CONSTANTS
} from "../../../../../../constants/ImageConstants.js"
import { ORDER } from "../../../../../../constants/InitTypeConstants.js"

export const TabPrePlantingScheduled = ({
  changePage,
  activeFilter,
  data,
  onRefresh = () => {}
}) => {
  const { t } = useTranslation()
  const { General, Order } = useSelector((state) => state)
  const params = useParams()
  const privileges = loadUserLogin().privilege
  const history = useHistory()
  const [selectedRows, setSelectedRows] = useState([])
  const [showCancelPopUp, setShowCancelPopUp] = useState(false)
  const [listCancelEnumList, setListCancelEnumList] = useState([])
  const dispatch = useDispatch()
  const [reasonOtherString, setReasonOtherString] = useState("")

  const onCancelBulk = () => {
    setShowCancelPopUp(false)
    const payload = {
      schedule_ids: selectedRows.map((e) => e?.id),
      cancel_enum_list: listCancelEnumList.filter((e) => e?.isSelected).map((e) => e?.enum_value),
      cancel_reason: reasonOtherString !== "" ? reasonOtherString : null
    }
    dispatch(BulkCancelOrderActions(payload))
  }

  useEffect(() => {
    if (
      General?.isFinishUpdateOrDelete &&
      !General?.isError &&
      General?.actionInitType === ORDER.CANCEL_ORDER_BULK
    ) {
      swal({
        text: t("messages_response_order_cancel"),
        icon: toAbsoluteUrl(ILLUSTRATION_CONSTANTS.SUCCESS_CANCEL_SCHEDULE),
        buttons: {
          redirect: {
            text: t("button_redirect_cancel_schedule"),
            className:
              "border border-primary-green bg-neutral-white text-primary-green p-2 font-weight-normal h-100",
            value: BULK_CANCEL_SCHEDULING_BUTTON.REDIRECT
          },
          confirm: {
            text: t("button_oke"),
            className: "btn bg-primary-green text-neutral-white p-2 font-weight-normal h-100",
            value: BULK_CANCEL_SCHEDULING_BUTTON.OK
          }
        }
      }).then((value) => {
        onRefresh()
        setSelectedRows([])
        if (value === BULK_CANCEL_SCHEDULING_BUTTON.REDIRECT) {
          let url = RoutesConstants.ORDER.LIST_PRE_PLANTING_BY_STATUS(
            ROUTING_STATUS.SPRAYING_PASCA_PLANTING_STRING.CANCEL
          )
          if (value.ctrlKey) {
            linkWithCtrl(url)
          } else {
            history.push(url)
          }
        }
      })
    }
  }, [General?.isFinishUpdateOrDelete])

  useEffect(() => {
    setReasonOtherString("")
    if (showCancelPopUp) {
      if (Array.isArray(Order?.cancelEnumList)) {
        loadCancelEnumList()
      } else {
        dispatch(GetCancelEnumList())
      }
    }
  }, [showCancelPopUp])

  useEffect(() => {
    if (Order?.cancelEnumList) {
      loadCancelEnumList()
    }
  }, [Order?.cancelEnumList])

  const loadCancelEnumList = () => {
    if (Order?.cancelEnumList) {
      setListCancelEnumList(
        Order?.cancelEnumList?.map((item) => {
          return {
            ...item,
            isSelected: false
          }
        })
      )
    }
  }

  const columns = [
    {
      dataField: "plantingSeason.area.name",
      text: t("table_header_area_name"),
      sort: true,
      formatter: formatterRowComponent,
      formatExtraData: {
        externalStyle: uiCode
      },
      headerStyle: () => {
        return { width: "20%" }
      },
      sortCaret: sortCaret
    },
    {
      dataField: "mitra",
      text: t("table_header_mitra"),
      sort: false,
      formatter: formatterRowComponent,
      formatExtraData: {
        externalStyle: uiMitra
      },
      sortCaret: sortCaret
    },
    {
      dataField: "farmer",
      text: t("table_header_farmer"),
      sort: false,
      formatter: formatterRowComponent,
      formatExtraData: {
        externalStyle: uiFarmer
      },
      sortCaret: sortCaret
    },
    {
      dataField: "activity_name",
      text: t("table_header_activity_type"),
      sort: false,
      formatter: formatterRowComponent,
      sortCaret: sortCaret,
      headerStyle: () => {
        return { width: "20%" }
      },
      formatExtraData: {
        externalStyle: uiActivity
      }
    },
    {
      dataField: "scheduleDate",
      text: t("table_header_activity_date"),
      sort: true,
      sortCaret: sortCaret,
      formatter: formatterRowComponent,
      formatExtraData: {
        externalStyle: uiDate
      }
    },
    {
      dataField: "modifiedDate",
      text: t("table_header_scheduled_date"),
      sort: true,
      formatter: formatterRowComponent,
      formatExtraData: {
        externalStyle: uiScheduling
      },
      sortCaret: sortCaret
    },
    {
      dataField: "scheduled_by",
      text: t("table_header_scheduled_by"),
      sort: false,
      formatter: formatterRowComponent,
      formatExtraData: {
        externalStyle: uiUser
      },
      sortCaret: sortCaret
    }
  ]

  const popUpCancelColumns = [
    {
      dataField: "plantingSeason.area.name",
      text: t("table_header_area_name"),
      formatter: formatterRowComponent,
      formatExtraData: {
        externalStyle: uiCodeCancel
      },
      headerStyle: () => {
        return { width: "20%" }
      }
    },
    {
      dataField: "mitra",
      text: t("table_header_mitra"),
      formatter: formatterRowComponent,
      formatExtraData: {
        externalStyle: uiMitra
      },
      headerStyle: () => {
        return { width: "20%" }
      }
    },
    {
      dataField: "land_area",
      text: t("table_header_land_area"),
      formatter: formatterRowComponent,
      formatExtraData: {
        externalStyle: uiLandArea
      },
      headerStyle: () => {
        return { width: "20%" }
      }
    },
    {
      dataField: "activity_name",
      text: t("table_header_activity_type"),
      formatter: formatterRowComponent,
      formatExtraData: {
        externalStyle: uiActivity
      },
      headerStyle: () => {
        return { width: "20%" }
      }
    }
  ]

  function uiScheduling(e) {
    return (
      <div>
        <div>{e?.created_date ? timeStampToDate(e?.created_date, "dd-MM-yyyy") : "-"}</div>
        <div>{e?.created_date ? timeStampToDate(e?.created_date, "HH:mm:ss") : "-"}</div>
      </div>
    )
  }

  function uiUser(e) {
    return (
      <>
        <div className={"text-dark font-weight-bolder  font-size-lg"}>
          {stringFormatting(e?.scheduler_name)}
        </div>
        <div>{stringFormatting(e?.scheduler_role)}</div>
      </>
    )
  }

  function uiCode(e) {
    return (
      <>
        <div className={"text-dark font-weight-bolder  font-size-lg"}>
          {stringFormatting(e?.area_name)}
        </div>
        <div className={"d-flex"}>
          <div>{stringFormatting(e?.sub_district)},&nbsp;</div>
          <div>{toMeter(e?.land_area)}</div>
        </div>
      </>
    )
  }

  function uiDate(e) {
    return (
      <div>
        <div>{e?.activity_date ? timeStampToDate(e?.activity_date, "dd-MM-yyyy") : "-"}</div>
      </div>
    )
  }

  function uiMitra(e) {
    return (
      <div>
        <div className={"text-dark font-weight-bolder  font-size-lg mb-1"}>
          {stringFormatting(e?.mitra_name)}
        </div>
        <div>{stringFormatting(e?.mitra_code)}</div>
      </div>
    )
  }

  function uiFarmer(e) {
    return (
      <div>
        <div className={"text-dark font-weight-bolder  font-size-lg mb-1"}>
          {stringFormatting(e?.farmer_name)}
        </div>
        <div>{stringFormatting(e?.farmer_code)}</div>
      </div>
    )
  }

  function uiActivity(e) {
    return (
      <div>
        <div className={"text-dark font-weight-bolder font-size-lg"}>
          {stringFormatting(e?.activity_name)}
        </div>
      </div>
    )
  }

  function uiCodeCancel(e) {
    return (
      <>
        <div className={"text-dark font-weight-bolder  font-size-lg"}>
          {stringFormatting(e?.area_name)}
        </div>
        <div className={"d-flex"}>
          <div>{stringFormatting(e?.sub_district)}</div>
        </div>
      </>
    )
  }

  function uiLandArea(e) {
    return (
      <div>
        <div className={"text-dark font-size-lg"}>{e?.land_area ? toMeter(e?.land_area) : "-"}</div>
      </div>
    )
  }

  const isSubmitCancelButtonDisabled =
    !listCancelEnumList?.some((reasonItem) => reasonItem.isSelected) ||
    listCancelEnumList?.some(
      (reasonItem) =>
        reasonItem.enum_value === SCHEDULING_STATUS_ENUM.OTHER &&
        reasonItem.isSelected &&
        reasonOtherString.trim() === ""
    )

  return (
    <div>
      <Card>
        <CardBody>
          {General.loading ? (
            <TableSkeleton column={6} row={10} />
          ) : data?.pageData?.length === 0 ? (
            <EmptyCard
              body={
                activeFilter
                  ? t("messages_response_data_not_found")
                  : t("messages_response_empty_state", { name: "penyemprotan" })
              }
            />
          ) : (
            ""
          )}
          <TableView
            dataTable={data?.pageData ?? []}
            loadingGetData={false}
            callbackAfterPageChange={changePage}
            columnProperties={columns}
            currentPage={data?.page?.currentPage}
            currentElement={data?.page?.currentElement}
            totalCount={data?.page?.totalCount}
            rowClasses={() => {
              return "cursor-pointer"
            }}
            keyField={"id"}
            selectable={true}
            useCustomCheckbox={true}
            selected={selectedRows.map((e) => e?.id)}
            onSelect={(row) => {
              setSelectedRows((prevState) => {
                const existingIndex = prevState.findIndex((e) => e?.id === row?.id)
                if (existingIndex > -1) {
                  return prevState.filter((e) => e?.id !== row?.id)
                } else {
                  // If the row is not selected, add it
                  return [...prevState, row]
                }
              })
            }}
            onSelectAll={(isSelect, rows) => {
              setSelectedRows(() => {
                if (isSelect) {
                  return rows.map((e) => e)
                } else {
                  return []
                }
              })
            }}
            rowEvents={{
              onClick: (e, row) => {
                if (privileges.indexOf(PRIVILEGE_ENUM.DETAIL_ORDER)) {
                  const url = RoutesConstants.ORDER.DETAIL_PRE_PLANTING(params?.tab, row?.id)
                  if (e.ctrlKey) {
                    linkWithCtrl(url)
                  } else {
                    history.push(url)
                  }
                }
              }
            }}
          />
        </CardBody>
      </Card>
      {selectedRows.length > 0 && (
        <FloatingSelectArea
          totalArea={selectedRows.length}
          labelIcon={ICON_CONSTANTS.MAP}
          labelFontSize={"md"}
          label={
            t("label_schedule_selected") +
            (selectedRows.filter(
              (e) => e?.scheduler_role === FIELD_OFFICER_ROLE_STRING.AGRONOMIST_SPV
            ).length > 0
              ? ` (${t("cant_edit_schedule", {
                  count: selectedRows.filter(
                    (e) => e?.scheduler_role === FIELD_OFFICER_ROLE_STRING.AGRONOMIST_SPV
                  ).length
                })}) `
              : ``)
          }
          customButtonSection={() => (
            <>
              <Button
                onClick={() => setShowCancelPopUp(true)}
                className={"d-flex align-items-center bg-neutral-red color-white border-0 ml-4"}>
                {t("label_cancel_scheduling")}
              </Button>
              <Button
                onClick={() => {
                  dispatch(
                    setSelectedDataReschedule({ schedule_ids: selectedRows.map((row) => row.id) })
                  ) // Extract IDs from selected rows
                  history.push(RoutesConstants.ORDER.RESCHEDULE_BULK_PASCA_PLANTING())
                }}
                disabled={
                  selectedRows.filter(
                    (e) => e?.scheduler_role === FIELD_OFFICER_ROLE_STRING.AGRONOMIST_SPV
                  ).length > 0
                }
                variant={
                  selectedRows.filter(
                    (e) => e?.scheduler_role === FIELD_OFFICER_ROLE_STRING.AGRONOMIST_SPV
                  ).length > 0
                    ? "outline-secondary"
                    : "primary"
                }
                className={"ml-4"}>
                {t("edit_schedule")}
              </Button>
            </>
          )}
        />
      )}
      <Popup
        show={showCancelPopUp}
        titleCustom={
          <h5 className="mb-0 font-weight-bolder">
            {t("label_schedule_list_and_reason_schedule_activity")}
          </h5>
        }
        bodyCustomClassName={"h-75"}
        size={"lg"}
        contentClassName={"h-75"}
        onCancel={() => {
          setShowCancelPopUp(false)
        }}
        showButton={false}
        bodyCustom={
          <div>
            <div
              style={{
                maxHeight: "40vh",
                overflowY: "auto",
                overflowX: "unset"
              }}
              className={"mb-5"}>
              <TableView
                dataTable={selectedRows}
                dataSize={selectedRows?.length}
                columnProperties={popUpCancelColumns}
                loadingGetData={false}
                callbackAfterPageChange={changePage}
                disablePagination={true}
              />
            </div>
            <Divider />
            <div className={"mt-5 custom-option"}>
              {listCancelEnumList && listCancelEnumList.length > 0
                ? listCancelEnumList?.reverse()?.map((cancelItem) => (
                    <div className={"d-flex align-items-center mb-5"} key={cancelItem?.enum_value}>
                      <div
                        className={"checkbox-container mr-5"}
                        onClick={() => {
                          setListCancelEnumList((prevList) => {
                            return prevList.map((item) => {
                              if (item.enum_value === cancelItem.enum_value) {
                                return {
                                  ...item,
                                  isSelected: !item.isSelected
                                }
                              }
                              return item
                            })
                          })
                        }}>
                        <input
                          type="checkbox"
                          className={"mb-2"}
                          checked={cancelItem?.isSelected}
                          readOnly
                        />
                        <span className="checkmark"></span>
                      </div>
                      {stringFormatting(cancelItem?.enum_string)}
                    </div>
                  ))
                : Array(5)
                    .fill()
                    .map((item) => (
                      <Skeleton
                        animation={"wave"}
                        variant={"text"}
                        width={"100%"}
                        key={item}
                        height={32}
                        className={"mb-5"}
                      />
                    ))}
              {listCancelEnumList
                ?.reverse()
                ?.filter((e) => e?.isSelected && e?.enum_value === SCHEDULING_STATUS_ENUM.OTHER)
                ?.length > 0 && (
                <textarea
                  rows={3}
                  className={"form-control mb-5"}
                  value={reasonOtherString}
                  onChange={(e) => {
                    setReasonOtherString(e.target.value)
                  }}
                  placeholder={t("label_input_reason")}
                />
              )}
            </div>
            <div className={"d-flex align-items-center justify-content-center w-100"}>
              <button
                onClick={() => {
                  setShowCancelPopUp(false)
                }}
                className={"btn btn-outline-maxxi flex-1 mr-5 font-weight-bold"}>
                {t("button_batal")}
              </button>
              <Button
                className={"font-weight-bold flex-1"}
                disabled={isSubmitCancelButtonDisabled}
                variant={"primary"}
                onClick={onCancelBulk}>
                {t("button_submit")}
              </Button>
            </div>
          </div>
        }
      />
    </div>
  )
}